import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import { LogoEmailRenderer } from "./email";
import { LogoBlockProps } from "./types";

export default function LogoWeb(props: LogoBlockProps) {
  return (
    <EmailComponentWrapper shop={props.shop}>
      <LogoEmailRenderer {...props} />
    </EmailComponentWrapper>
  );
}
